"use client"
/* */
import '@mittwald/password-tools-js/rules';

const getStateFromLatestPolicyValidationResult = (result) => {
  if (!result.isValid && result.ruleResults.length >= 1) {
    const failingRule = result.ruleResults.find((r) => !r.isValid);
    if (!failingRule) {
      return {
        isValid: false,
        identifier: "failingComplexity"
      };
    }
    return failingRule;
  }
  if (result.isValid === "indeterminate") {
    return void 0;
  }
  if (result.complexity.actual <= result.complexity.min) {
    return {
      isValid: result.isValid,
      identifier: "optimizeComplexity"
    };
  }
  return {
    isValid: true,
    identifier: "securePassword"
  };
};

export { getStateFromLatestPolicyValidationResult as default, getStateFromLatestPolicyValidationResult };
//# sourceMappingURL=getStateFromLatestPolicyValidationResult.mjs.map
